var map = {
	"./BisCoffSC.svg": 6720,
	"./Black Currant Blast FB.svg": 2794,
	"./Black ForestSC.svg": 2148,
	"./Blueberry Blast FB.svg": 9888,
	"./Butterscotch_Blast_FB.svg": 5820,
	"./Choco Almond FB.svg": 6795,
	"./Choco ChipSC.svg": 3688,
	"./Choco-strawberry FB.svg": 4190,
	"./Choco-vanilla-FB.svg": 3199,
	"./Choheartcake.svg": 3026,
	"./Disney Princess Birthday Cake FB.svg": 3414,
	"./Ferro Blast FB.svg": 5426,
	"./FruitSC.svg": 2174,
	"./Mexican CakeSC.svg": 4217,
	"./Milky Blast FB.svg": 2422,
	"./Pineapple Blast FB.svg": 330,
	"./Rasamalai Blast FB.svg": 8219,
	"./Red heart cakeFB.svg": 3453,
	"./RedVelvetBlastFB.svg": 1517,
	"./White Forest Blast FB.svg": 649,
	"./black_forest.svg": 2537,
	"./blackcurrentFB.svg": 9922,
	"./bluebery.svg": 7794,
	"./butter_scotch.svg": 8425,
	"./cake_default.svg": 4312,
	"./choco_coffee.svg": 7744,
	"./choco_dark.svg": 3415,
	"./chocolate.svg": 3580,
	"./dutch-chocolate-heart-cake FB.svg": 6457,
	"./mango_crush.svg": 4044,
	"./pineappleFB.svg": 5248,
	"./pineapple_cake.svg": 9051,
	"./redv.svg": 8483,
	"./strawberry.svg": 5741,
	"./vanilla.svg": 9635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9010;